import { render, staticRenderFns } from "./consultaInventarios.vue?vue&type=template&id=3a06f028&"
import script from "./consultaInventarios.vue?vue&type=script&lang=js&"
export * from "./consultaInventarios.vue?vue&type=script&lang=js&"
import style0 from "./consultaInventarios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports